import {CustomPriceInfoModel} from './custom-price-info.model';
import {RPriceInfoModel} from './r-price-info.model';

export class PriceInfoModel {
    customPriceInfo: CustomPriceInfoModel;
    rPriceInfo: RPriceInfoModel[];
    selectedPrice: string;  // RPriceIdentifierEnum

    public static getNewInstance( rPrices: RPriceInfoModel[] = []): PriceInfoModel {
        const result = new PriceInfoModel();
        result.rPriceInfo = rPrices;
        result.customPriceInfo = new CustomPriceInfoModel();
        return result;
    }

}
